import { resolvePublicEnv } from './runtimeEnv';

// Runtime values let one image serve multiple environments. The build value is
// retained for local development and deployments that still pass Docker args.
const configuredApiBaseUrl = resolvePublicEnv(
  'REACT_APP_API_BASE_URL',
  process.env.REACT_APP_API_BASE_URL,
);
const resolvedApiBaseUrl = configuredApiBaseUrl
  || (process.env.NODE_ENV === 'test' ? 'http://localhost/api/customer-app' : '');

if (!resolvedApiBaseUrl) {
  throw new Error('REACT_APP_API_BASE_URL is required to run the storefront.');
}

try {
  const parsedApiBaseUrl = new URL(resolvedApiBaseUrl);
  if (!['http:', 'https:'].includes(parsedApiBaseUrl.protocol)) {
    throw new Error('unsupported protocol');
  }
} catch {
  throw new Error('REACT_APP_API_BASE_URL must be a valid HTTP(S) URL.');
}

export const API_BASE_URL = resolvedApiBaseUrl.replace(/\/+$/, '');

// The backend mounts the address-lookup proxy beside the customer API
// (/api/places next to /api/customer-app), so it is derived from the same
// runtime value rather than configured separately. null when the API base does
// not follow that layout; address lookup is then reported as unavailable.
export const derivePlacesBaseUrl = (apiBaseUrl) => {
  try {
    const url = new URL(apiBaseUrl);
    const pathname = url.pathname.replace(/\/+$/, '');
    if (!/\/customer-app$/.test(pathname)) return null;
    url.pathname = pathname.replace(/\/customer-app$/, '/places');
    url.search = '';
    url.hash = '';
    return url.toString().replace(/\/+$/, '');
  } catch {
    return null;
  }
};

export const PLACES_API_BASE_URL = derivePlacesBaseUrl(API_BASE_URL);

export const TOKEN_STORAGE_KEYS = {
  access: 'fnh_access_token',
  refresh: 'fnh_refresh_token',
};

export const RAZORPAY_CHECKOUT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';
